<mat-menu #menu="matMenu" class="action-user__menu" aria-label="Conta de {{ identity() }}">
  <div class="action-user__identity stack">
    <span class="au-identity__label mat-font-body-md mat-text-on-surface-variant">Conectado como</span>
    <span class="action-user__identity-email text-truncate">{{ identity() }}</span>
  </div>

  <mat-divider />

  <a mat-menu-item class="action-user__account" routerLink="/account" routerLinkActive="is-active" ariaCurrentWhenActive="page">
    <mat-icon>manage_accounts</mat-icon>
    <span class="action-user__action-label">Minha conta</span>
  </a>

  <button type="button" mat-menu-item class="action-user__signout" (click)="signOut()">
    <mat-icon>logout</mat-icon>
    <span class="action-user__action-label">Sair</span>
  </button>
</mat-menu>
